<template>
    <Dialog v-model:open="isOpen" @update:open="onOpen">
        <DialogTrigger as-child>
            <Button class="w-full justify-between">
                <span>{{ props.title }}</span>
                <Icon name="search" />
            </Button>
        </DialogTrigger>
        <DialogContent class="max-w-2xl max-h-screen">
            <DialogHeader>
                <DialogTitle>{{ props.title }}</DialogTitle>
            </DialogHeader>
            <div id="cms-search" @click="handleClick"></div>
        </DialogContent>
    </Dialog>
</template>
<script setup>
// Not using TypeScript here because the PagefindUI doesn't provide types
// Not including the stylesheet because we'll customize here in the style block
import { PagefindUI } from "@pagefind/default-ui";

const props = defineProps({
    title: { type: String, required: true },
    root: { type: String, required: true },
    searchType: {
        type: String,
        required: true,
        validator: (value) => ["docs", "blog", "authorized-channel-insights"].includes(value),
    },
});

const isOpen = ref(false);
let search;
const { cmsBaseUrl } = useRuntimeConfig().public;
// for example, https://cms.trustedparts.com/dev/pagefind/blog/
const bundlePath = `${cmsBaseUrl}pagefind/${props.searchType}/`;

// Create and destroy the search every time the dialog opens, perfect for language switching
function onOpen(isOpen) {
    if (isOpen) {
        nextTick(() => {
            search = new PagefindUI({
                element: "#cms-search",
                showSubResults: true,
                bundlePath,
                baseUrl: "/",
                showImages: false,
                resetStyles: false,
            });
            const inputEl = document.querySelector("#cms-search input");
            if (inputEl) inputEl.focus();
        });
    } else {
        if (search) search.destroy();
    }
}

async function handleClick(event) {
    // make sure links close the search box, do client nav
    if (event.target.tagName === "A") {
        event.preventDefault();
        isOpen.value = false;
        return await navigateTo(event.target.getAttribute("href"));
    }
}
</script>
<style>
.pagefind-ui__search-input {
    width: 100%;
}
.pagefind-ui__search-clear {
    display: none;
}

.pagefind-ui__results {
    overflow: auto;
    max-height: calc(100vh - 12rem);
}

.pagefind-ui__result {
    border-bottom: 1px solid var(--color-gray-200);
    margin-bottom: calc(var(--spacing) * 2);
}

.pagefind-ui__result-title {
    font-weight: bold;
    margin: 0;
    font-size: var(--text-base);
    line-height: var(--tw-leading, var(--text-base--line-height));
}

.pagefind-ui__result-excerpt mark {
    background-color: var(--color-accent-highlight);
}

.pagefind-ui__result-nested {
    margin-left: calc(var(--spacing) * 8);
}
</style>
